import { Tab as BootstrapTab } from "react-bootstrap";
import styled, { css } from "styled-components";
const Tab = styled(BootstrapTab)(
  ({ theme }) => css`
    background-color: ${theme.colors.global.contentBackground};
    border: 1px solid ${theme.colors.variant.default};
    border-top: 0;
    border-radius: 0 0 4px 4px;
    padding: 9px;
  `
);
export default Tab;
